export const headerNavigation = {
  partitions: {
    key: "partitions",
    label: "Bathroom Partitions",
    href: "/bathroom-partitions",
    children: [
      { label: "Materials", href: "/bathroom-partitions#materials" },
      { label: "Budget Calculator", href: "/partition-budget-calculator#partition-budget-calculator" },
      { label: "Mounting Styles", href: "/resources/mounting-styles" },
      { label: "Privacy Options", href: "/resources/privacy-options" },
    ],
  },
  accessories: {
    key: "accessories",
    label: "Bathroom Accessories",
    href: "/commercial-restroom-accessories",
    children: [
      { label: "Shop All Models", href: "/commercial-restroom-accessories#catalog-results" },
      { label: "Shop ASI", href: "/commercial-restroom-accessories?brand=asi" },
      { label: "Shop Bobrick", href: "/commercial-restroom-accessories?brand=bobrick" },
      { label: "Shop Bradley", href: "/commercial-restroom-accessories?brand=bradley" },
    ],
  },
  direct: [
    { label: "Projects", href: "/projects" },
    { label: "Markets", href: "/service-areas" },
    { label: "Contact", href: "/contact-partition-stalls" },
  ],
} as const;
